
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabservicefrompunetogujrat() {



    const cardData =
    {
        keyword: 'Pune to Gujarat Cabs',
        heading: 'Platinum24 Cabs: Pune to Gujarat Cabs',
        headingDescription: ' Platinum24 Cabs provides dependable Pune to Gujarat cab services, perfect for family vacations, religious yatras, and business travel across Gujarat’s major cities. Whether you are visiting Ahmedabad for work, Somnath and Dwarka for pilgrimage, or Gir National Park for leisure, our well-maintained sedans, SUVs, and luxury cars ensure a comfortable and safe journey. With professional chauffeurs, timely pickups, and transparent pricing, we make long-distance travel stress-free and enjoyable. From one-way drops to round trips, Platinum24 Cabs is your trusted travel partner for reliable Pune to Gujarat rides.',

        top: 'Top Places to Visit in Gujarat with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Somnath Jyotirlinga Temple",
    "description": "Somnath Temple, one of the 12 Jyotirlingas of Lord Shiva, is Gujarat’s most sacred pilgrimage site. Destroyed and rebuilt multiple times, it stands today as a symbol of resilience and devotion. Its Chalukyan-style architecture and sea-facing backdrop make it mesmerizing. The evening aarti and light-and-sound show narrate its history. Devotees believe darshan here ensures moksha. Somnath is Gujarat’s divine spiritual beacon."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park, the only home of the Asiatic lions, is Gujarat’s wildlife crown jewel. Jeep safaris allow visitors to spot lions, leopards, deer, and over 300 species of birds. The park’s rugged terrain, rivers, and dry forests add to the thrill. Winter is the best season to explore its rich biodiversity. Conservation here has saved the lion species from extinction. Gir is Gujarat’s ultimate wildlife experience."
  },
  {
    "title": "Dwarkadhish Temple",
    "description": "Dwarkadhish Temple, dedicated to Lord Krishna, is a major Char Dham pilgrimage in Gujarat. Built over 2,000 years ago, its towering shikhara rises 79 meters above sea level. Pilgrims believe Lord Krishna ruled his kingdom here. The temple overlooks the Gomti River and Arabian Sea. Evening aartis and Janmashtami celebrations attract thousands. Dwarka is Gujarat’s eternal city of devotion."
  },
  {
    "title": "Statue of Unity",
    "description": "The Statue of Unity, dedicated to Sardar Vallabhbhai Patel, is the world’s tallest statue at 182 meters. Located near Kevadia on the Narmada River, it is surrounded by gardens, museums, and a viewing gallery. Laser shows and boat rides enhance the visit. The site also promotes eco-tourism with jungle safaris and riverfront activities. It symbolizes India’s unity and pride. The Statue of Unity is Gujarat’s modern marvel."
  },
  {
    "title": "Rann of Kutch",
    "description": "The Rann of Kutch is a vast salt desert that glows white under the moonlight. The Rann Utsav, held every winter, showcases folk music, dance, handicrafts, and camel rides. Tourists stay in luxury tents for a cultural desert experience. The surreal landscapes attract photographers worldwide. Flamingos and migratory birds add natural beauty. The Rann of Kutch is Gujarat’s magical cultural festival land."
  },
  {
    "title": "Champaner-Pavagadh Archaeological Park",
    "description": "A UNESCO World Heritage Site, Champaner-Pavagadh Archaeological Park combines forts, temples, mosques, and palaces. It reflects pre-Mughal Islamic architecture and Hindu craftsmanship. The Kalika Mata Temple atop Pavagadh Hill attracts thousands of pilgrims. Scenic ropeway rides make the climb easier. History buffs love exploring ancient ruins here. Champaner-Pavagadh is Gujarat’s heritage showcase."
  },
  {
    "title": "Sabarmati Ashram, Ahmedabad",
    "description": "Sabarmati Ashram, founded by Mahatma Gandhi in 1917, was the base of India’s freedom movement. Visitors explore Hriday Kunj, Gandhi’s residence, and exhibits of his life and philosophy. The Ashram on the banks of the Sabarmati River offers peace and inspiration. It is a must-visit for history and spirituality lovers. Educational tours make it enriching for students. Sabarmati Ashram is Gujarat’s beacon of non-violence."
  },
  {
    "title": "Modhera Sun Temple",
    "description": "The Sun Temple at Modhera, built in the 11th century by the Solanki dynasty, is a masterpiece of temple architecture. It is dedicated to the Sun God and aligned to capture the first rays of the sun. The intricate carvings and stepwell-style kund fascinate visitors. Cultural festivals and light shows add vibrancy. It is often compared to Konark Sun Temple in Odisha. Modhera is Gujarat’s architectural marvel."
  },
  {
    "title": "Saputara Hill Station",
    "description": "Saputara, located in the Western Ghats, is Gujarat’s only hill station. It offers pleasant weather, lush green valleys, and tribal culture. Visitors enjoy boating at Saputara Lake, ropeway rides, and sunset viewpoints. Monsoon makes the region especially beautiful with waterfalls. Local tribal art and handicrafts add cultural charm. Saputara is Gujarat’s refreshing mountain retreat."
  },
  {
    "title": "Laxmi Vilas Palace, Vadodara",
    "description": "Laxmi Vilas Palace, built in 1890 by the Gaekwad dynasty, is four times larger than Buckingham Palace. Its Indo-Saracenic architecture, stained glass, and marble interiors are breathtaking. The palace complex houses museums, armories, and golf courses. Visitors admire royal collections and cultural performances. It is still the residence of the royal family of Baroda. Laxmi Vilas Palace is Gujarat’s royal heritage jewel."
  }
],


     "services": [
    {
      "name": "Pune to Gujarat Cab",
      "description": "Enjoy a comfortable and reliable ride with our Pune to Gujarat Cab service, ideal for long-distance travel across states. Our well-maintained vehicles and experienced drivers ensure a smooth journey, whether you're traveling for business, leisure, or a family visit. With multiple car options, transparent pricing, and easy booking, we make interstate travel hassle-free and enjoyable."
    },
    {
      "name": "Pune to Gujarat Taxi",
      "description": "Travel with ease using our Pune to Gujarat Taxi service, offering timely and safe transportation for all types of travelers. From solo commuters to families, our range of taxis cater to different needs. With GPS-enabled tracking, courteous drivers, and 24/7 availability, we ensure your journey from Pune to Gujarat is comfortable and secure."
    },
    {
      "name": "Book Pune to Gujarat Cab",
      "description": "Booking your ride from Pune to Gujarat is now simpler than ever with our user-friendly platform. Choose from a wide selection of vehicles, customize your trip, and enjoy instant confirmation. Whether it's a one-way trip or a round journey, our booking service guarantees convenience and reliability at competitive rates."
    },
    {
      "name": "Pune to Gujarat Cab Service",
      "description": "Our Pune to Gujarat Cab Service offers dependable intercity travel with trained drivers and well-kept vehicles. Whether it’s an urgent trip or a planned vacation, we ensure timely departures, safe driving, and comfort throughout your journey. Special packages and round-the-clock customer support make us your trusted travel partner."
    },
    {
      "name": "Pune to Gujarat Taxi Fare",
      "description": "Curious about Pune to Gujarat Taxi Fare? We offer transparent and competitive pricing with no hidden charges. Whether you choose an economy car or a luxury vehicle, our fare structure is clearly communicated upfront, ensuring trust and affordability for all travelers."
    },
    {
      "name": "Pune to Gujarat Car Hire",
      "description": "Hire a car for your Pune to Gujarat journey with flexible rental options and a wide variety of vehicle choices. From compact cars to spacious SUVs, our car hire service caters to your comfort and travel needs. Choose between self-drive or chauffeur-driven options, all at reasonable rates."
    },
    {
      "name": "Pune to Gujarat One Way Cab",
      "description": "Save money and travel smart with our Pune to Gujarat One Way Cab service. Ideal for single trips without the return fare, our service is economical and convenient. Choose your pickup time, vehicle type, and enjoy a direct, uninterrupted ride to your destination."
    },
    {
      "name": "Gujarat to Pune Taxi",
      "description": "Need a ride back? Our Gujarat to Pune Taxi service ensures a smooth and timely return journey with the same standards of comfort and safety. Easily book online or through our app and travel stress-free with our professional drivers and clean vehicles."
    },
    {
      "name": "Pune to Gujarat Outstation Cabs",
      "description": "Embark on a worry-free long-distance journey with our Pune to Gujarat Outstation Cabs. Designed for intercity travel, our cabs are equipped with essentials for extended rides. Enjoy reliable service, experienced drivers, and on-time pickups for a seamless travel experience."
    },
    {
      "name": "Pune to Gujarat Cab Booking",
      "description": "Make your Pune to Gujarat Cab Booking fast and easy with our digital platform. Compare car types, check fare estimates, and schedule your trip in minutes. Our seamless booking system ensures prompt confirmations, giving you peace of mind before you hit the road."
    },
    {
      "name": "Pune to Gujarat Taxi Charges",
      "description": "We believe in pricing transparency. Check Pune to Gujarat Taxi Charges in advance with our fare calculator and receive a detailed breakdown before booking. Our competitive rates are designed to suit every budget, with no surprises or hidden costs at the end of your journey."
    },
    {
      "name": "Cab Service from Pune to Gujarat",
      "description": "Our Cab Service from Pune to Gujarat provides dependable intercity travel with professional drivers, sanitized vehicles, and punctual pickups. Whether you need a ride for work, a family trip, or sightseeing, we ensure your journey is smooth, safe, and enjoyable."
    },
    {
      "name": "Affordable Pune to Gujarat Cabs",
      "description": "Travel doesn’t have to be expensive. With our Affordable Pune to Gujarat Cabs, you get budget-friendly fares without compromising on quality. Perfect for students, families, and solo travelers looking for comfort on a budget, our fleet ensures economical long-distance travel."
    },
    {
      "name": "Pune to Gujarat Road Trip Taxi",
      "description": "Turn your journey into an experience with our Pune to Gujarat Road Trip Taxi service. Enjoy scenic views, stopovers, and a flexible schedule while traveling in a comfortable, air-conditioned cab. Ideal for travelers who enjoy the ride as much as the destination."
    },
    {
      "name": "Pune to Gujarat Car Rental",
      "description": "Rent a car from Pune to Gujarat for complete travel flexibility. Our Pune to Gujarat Car Rental options include self-drive and chauffeur-driven choices, perfect for day trips, business travel, or family vacations. Enjoy well-maintained vehicles, 24/7 support, and competitive prices for a stress-free rental experience."
    }
  ],
  "tableData": [
    ["Pune to Gujarat Cab", "Pune to Gujarat Taxi"],
    ["Book Pune to Gujarat Cab", "Pune to Gujarat Cab Service"],
    ["Pune to Gujarat Taxi Fare", "Pune to Gujarat Car Hire"],
    ["Pune to Gujarat One Way Cab", "Gujarat to Pune Taxi"],
    ["Pune to Gujarat Outstation Cabs", "Pune to Gujarat Cab Booking"],
    ["Pune to Gujarat Taxi Charges", "Cab Service from Pune to Gujarat"],
    ["Affordable Pune to Gujarat Cabs", "Pune to Gujarat Road Trip Taxi"],
    ["Pune to Gujarat Car Rental", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Gujarat Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers dependable and comfortable cab services from Pune to Gujarat, ensuring a smooth journey."
  },
  {
    "WhyChooseheading": "Variety of Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Choose from sedans, SUVs, and tempo travellers perfect for your Pune to Gujarat trip, accommodating different group sizes."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles for Your Safety",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to provide a safe and healthy travel experience."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Pune-Gujarat Routes",
    "WhyChoosedescription": "Our drivers are well-versed with routes between Pune and Gujarat to ensure timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy clear and affordable fares from Pune to Gujarat, including tolls, fuel, and driver charges."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our support team is available around the clock to assist with your Pune to Gujarat cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Packages for One-Way and Round Trips",
    "WhyChoosedescription": "Choose from customizable rental options for short or extended travel between Pune and Gujarat."
  },
  {
    "WhyChooseheading": "Quick Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Gujarat cab quickly via our website or app with real-time booking confirmation."
  }
]
















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Gujarat cab services?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services from Pune to various cities in Gujarat.',
    },
    {
        question: 'How can I book a cab from Pune to Gujarat with Platinum24 Cabs?',
        answer: 'You can book your cab easily through our website, mobile app, or by calling our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for Pune to Gujarat travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars for Pune to Gujarat travel to suit your comfort and budget.',
    },
    {
        question: 'Is one-way cab service available from Pune to Gujarat?',
        answer: 'Yes, we offer both one-way and round-trip cab services from Pune to Gujarat.',
    },
    {
        question: 'Are the drivers experienced for long-distance routes like Pune to Gujarat?',
        answer: 'Absolutely, our drivers are trained, experienced, and well-versed with the Pune to Gujarat route.',
    },
    {
        question: 'Are there fixed or customizable packages for Pune to Gujarat cabs?',
        answer: 'We provide flexible packages that can be customized as per your travel requirements and destinations in Gujarat.',
    },
    {
        question: 'Are safety and hygiene protocols followed for Pune to Gujarat travel?',
        answer: 'Yes, our cabs are sanitized regularly and drivers follow all safety and hygiene measures.',
    },
    {
        question: 'Is Pune to Gujarat cab service available 24x7?',
        answer: 'Yes, we offer 24x7 cab services from Pune to Gujarat to match your travel schedule.',
    },
    {
        question: 'What payment methods are accepted for Pune to Gujarat cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and all major credit/debit cards.',
    },
    {
        question: 'Can I choose my pickup and drop-off locations in Pune and Gujarat?',
        answer: 'Yes, you can specify your exact pickup and drop-off points for your Pune to Gujarat journey.',
    },
];
const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Patel',
        feedback: 'Platinum24 Cabs made my Pune to Ahmedabad trip smooth and stress-free. Great service and polite driver!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Prachi Mehta',
        feedback: 'I was impressed by the punctuality and cleanliness of the cab. Best option for Pune to Gujarat travel.',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToGujaratCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Gujarat Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-gujarat-cab.jpg",
  "description": "Book Pune to Gujarat cab service with Platinum24 Cabs. Choose from comfortable AC sedans, SUVs, and more for one-way and round trips. Affordable, reliable, and available 24/7 for your outstation travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-gujarat-cab-service"
  }
};






    return (
        <div>


<Helmet>
  <title>Pune to Gujarat Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Gujarat cab service with Platinum24 Cabs. Choose from comfortable AC sedans, SUVs, and more for one-way and round trips. Affordable, reliable, and available 24/7 for your outstation travel needs."
  />
  <meta
    name="keywords"
    content="Pune to Gujarat Cab, Pune to Gujarat Taxi, Book Pune to Gujarat Cab, Pune to Gujarat Cab Service, Pune to Gujarat Taxi Fare, Pune to Gujarat Car Hire, Pune to Gujarat One Way Cab, Gujarat to Pune Taxi, Pune to Gujarat Outstation Cabs, Pune to Gujarat Cab Booking, Pune to Gujarat Taxi Charges, Cab Service from Pune to Gujarat, Affordable Pune to Gujarat Cabs, Pune to Gujarat Road Trip Taxi, Pune to Gujarat Car Rental"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToGujaratCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/97.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabservicefrompunetogujrat;